import * as safeJWTDecode from './safeJWTDecode'

const getPermissions = decoded => {
  return ((decoded.user || {}).perfil || {}).permissoes || []
}

const can = (method, { functionality, token }) => {
  if (!method || !functionality || !token) return false

  const decoded = safeJWTDecode.decode(token)
  if (!decoded) return false

  const permissions = getPermissions(decoded)

  const permission = permissions.find(item => {
    const {
      funcionalidade: { alias }
    } = item

    return new RegExp(functionality).test(alias) && item[method]
  })

  return (permission || {})[method]
}

export const findPermission = (alias, token) => {
  const decoded = safeJWTDecode.decode(token)
  if (!decoded) return {}

  return (
    getPermissions(decoded).find(item => new RegExp(alias).test(item.funcionalidade.alias)) || {}
  )
}

export const readOnly = (alias, token) => {
  const decoded = safeJWTDecode.decode(token)
  if (!decoded) return true

  return !!getPermissions(decoded).find(item => {
    const regexMatch = new RegExp(alias).test(item.funcionalidade.alias)
    const readOnly = item.ler && !item.editar

    return regexMatch && readOnly
  })
}

export const canRead = (...args) => can('ler', ...args)
export const canEdit = (...args) => can('editar', ...args)
export const canRemove = (...args) => can('remover', ...args)



// WEBPACK FOOTER //
// ./src/utils/permissions.js